module.exports = "/packs/001-ffb6d8eaaf1cc2f36b3928f4aeb8f86a.svg";